var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNotificationWhite = function SvgNotificationWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.406 5.502A6 6 0 0 0 6 10.442v6.184h12v-6.185a6 6 0 0 0-2.594-4.94ZM7.458 3.855A8 8 0 0 1 20 10.441v6.185h1v2h-4.426l-.009.02a4.899 4.899 0 0 1-1.03 1.466 5.008 5.008 0 0 1-1.622 1.063 5.088 5.088 0 0 1-3.826 0 5.007 5.007 0 0 1-1.623-1.063 4.9 4.9 0 0 1-1.029-1.466l-.009-.02H3v-2h1v-6.185a8 8 0 0 1 3.458-6.586Zm6.677 14.83.039-.04H9.826l.039.04c.277.27.607.488.974.637a3.086 3.086 0 0 0 2.322 0c.367-.149.697-.366.974-.638Z",
    fill: "#fff"
  })));
};

export default SvgNotificationWhite;